<div fxLayout="row wrap">
  <Teranet-PageTitle [PageTitle]="'Edit SFTP'"></Teranet-PageTitle>
  <mat-divider></mat-divider>
</div>
<div mat-dialog-content>
  <div fxLayout="column">
    <div class="teranet-padding" fxFlex="100" fxLayout="column">
      <form
        [formGroup]="sftpForm"
        #sftpFormRef="ngForm"
        novalidate
        (ngSubmit)="updateSftp(sftpFormRef)"
      >
        <div fxFlex="100">
          <div fxLayout="column" fxLayoutAlign="center stretch">
            <div fxLayout.xs="column" fxLayout="row wrap">
              <div class="form-group-flex-column">
                <mat-label class="required-field-after">Host Name</mat-label>
                <mat-form-field class="mat-form-field-lg" appearance="outline">
                  <input
                    matInput
                    data-lpignore="true"
                    formControlName="hostname"
                    #hostname
                    required
                  />
                  <mat-error *ngIf="sftpForm.get('hostname').hasError('required')">
                    Required
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div fxLayout.xs="column" fxLayout="row wrap">
              <div class="form-group-flex-column">
                <mat-label class="required-field-after">SFTP Name</mat-label>
                <mat-form-field class="mat-form-field-lg" appearance="outline">
                  <input
                    matInput
                    data-lpignore="true"
                    formControlName="sftpname"
                    #sftpname
                    required
                  />
                  <mat-error *ngIf="sftpForm.get('sftpname').hasError('required')">
                    Required
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div fxLayout.xs="column" fxLayout="row wrap">
              <div class="form-group-flex-column">
                <mat-label class="required-field-after">Port</mat-label>
                <mat-form-field class="mat-form-field-lg" appearance="outline">
                  <input matInput data-lpignore="true" formControlName="port" #port required />
                  <mat-error *ngIf="sftpForm.get('port').hasError('required')">
                    Required
                  </mat-error>
                  <mat-error *ngIf="sftpForm.get('port').hasError('pattern')">
                    Please input a number
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div fxLayout.xs="column" fxLayout="row wrap">
              <div class="form-group-flex-column">
                <mat-label class="required-field-after">User Name</mat-label>
                <mat-form-field class="mat-form-field-lg" appearance="outline">
                  <input
                    matInput
                    data-lpignore="true"
                    formControlName="username"
                    #username
                    required
                  />
                  <mat-error *ngIf="sftpForm.get('username').hasError('required')">
                    Required
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div fxLayout.xs="column" fxLayout="row wrap">
              <div class="form-group-flex-column">
                <mat-label class="required-field-after">Password</mat-label>
                <mat-form-field class="mat-form-field-lg" appearance="outline">
                  <input
                    matInput
                    data-lpignore="true"
                    formControlName="password"
                    #password
                    required
                  />
                  <mat-hint *ngIf="sftpForm.get('password').value">Enter your password</mat-hint>
                  <mat-error *ngIf="sftpForm.get('password').hasError('required')">
                    Required
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div fxLayout.xs="column" fxLayout="row wrap">
              <div class="form-group-flex-column">
                <mat-checkbox formControlName="isexternal" class="checkbox-margin"
                  >Is External</mat-checkbox
                >
              </div>
              <div class="form-group-flex-column">
                <mat-checkbox formControlName="isenabled" class="checkbox-margin"
                  >Enabled</mat-checkbox
                >
              </div>
            </div>
          </div>
          <div fxLayout="row wrap" fxLayoutAlign="end">
            <button mat-raised-button class="plain-button" type="button" (click)="onClose()">
              Cancel
            </button>
            <button mat-raised-button class="theme-button" type="submit">Save</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
